import { MenuItem, TextFieldProps } from "@mui/material";
import { RHFSelect } from "./RHFSelect";

const STATUS_OPTIONS = [
  {
    value: 'USD',
    label: '$ - U.S. Dollars (USD)',
  },
  {
    value: 'RUB',
    label: '₽ - Рубли (RUB)',
  },
  {
    value: 'EUR',
    label: '€ - Euro (EUR)',
  },
  {
    value: 'CNY',
    label: '¥ - Chinese (CNY)',
  },
];

type RHFSelectProps = TextFieldProps & {
  name: string;
  native?: boolean;
  maxHeight?: boolean | number;
};

// eslint-disable-next-line arrow-body-style
export const RHFCurrency = ({ name, label, ...other }: RHFSelectProps) => {
  return (
    <RHFSelect
      fullWidth
      name={name}
      label={label}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        native: false,
        sx: {
          textTransform: 'capitalize',
          '& .MuiInputBase-input': {
            font: 'menu',
          },
        },
      }}
      size="small"
      {...other}
    >
      {STATUS_OPTIONS.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            mx: 1,
            my: 0.5,
            borderRadius: 0.75,
            typography: 'body2',
            textTransform: 'capitalize',
            font: 'menu',
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </RHFSelect>
  );
};
